export const productInitialValues = {
  products: [],
  productLoader: false,
  productMinPrice: 0,
  productMaxPrice: 0,
};
